export default "__VITE_ASSET__DdZ6LV4p__"